import React from 'react';
import { IconProps } from './types';

export const ShipSmall = ({ className, title }: IconProps) => (
  <svg
    id="Laag_2"
    data-name="Laag 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
    className={className}
  >
    <title>{title}</title>
    <path d="M29.81,25.25a1,1,0,0,0-1.38-.33l-4,2.44-4.76-2.75-4.52,2.76-4.81-2.76L5.82,27.36,2,25.13a1,1,0,0,0-1,1.73l4.87,2.83,4.52-2.76,4.81,2.76,4.51-2.76,4.77,2.76,5-3.07A1,1,0,0,0,29.81,25.25Z" />
    <path d="M8.75,24.8a1,1,0,0,0,.18-1.4L7.59,21.67l6.62-2.14v5.33a1,1,0,0,0,2,0V19.53l6.63,2.14-1.37,1.77a1,1,0,0,0,.18,1.4,1,1,0,0,0,.61.21,1,1,0,0,0,.79-.39l3.11-4L15.21,17.1,4.27,20.64l3.07,4A1,1,0,0,0,8.75,24.8Z" />
    <path d="M21.79,18.16V9.78H19.18v-3H11.25v3H8.63v8.38l6.58-2.45ZM12.87,8.44h4.68V9.78H12.87Zm-2.24,3.34h9.16v3.5l-4.58-1.7-4.58,1.7Z" />
  </svg>
);
